import axios from "../axios";
import * as url from "./url";

// In-flight mappings requests, keyed by org id. Concurrent callers
// (e.g. every chart on a dashboard refreshing at once) share a single GET,
// and every caller's onFetched is still invoked on success.
let inflightByOrg = {};

export const isMappingsLoaded = mappingMasterList =>
  !!mappingMasterList && !Array.isArray(mappingMasterList);

/**
 * Resolves with the org's KPI mappings, fetching them once per org if they
 * are not already in redux. Concurrent callers share the same request.
 *
 * @param {Object|string} organizationId - org object (with _id) or org id string
 * @param {*} mappingMasterList - current redux value of state.mappingMaster.mappingMasterList
 * @param {Function} onFetched - called with the fetched mapping so the caller can dispatch it to redux
 */
export const ensureMappings = (organizationId, mappingMasterList, onFetched) => {
  if (isMappingsLoaded(mappingMasterList)) {
    return Promise.resolve(mappingMasterList);
  }

  const orgId = organizationId && organizationId._id ? organizationId._id : organizationId;

  if (!inflightByOrg[orgId]) {
    const entry = { callbacks: [] };
    entry.promise = axios
      .get(url.getExistingMappings(orgId))
      .then(({ data }) => {
        const mapping = data.data.mapping;
        delete inflightByOrg[orgId];
        entry.callbacks.forEach(cb => {
          try {
            cb(mapping);
          } catch (callbackError) {
            console.log("ensureMappings onFetched error: ", callbackError);
          }
        });
        return mapping;
      })
      .catch(error => {
        delete inflightByOrg[orgId];
        throw error;
      });
    inflightByOrg[orgId] = entry;
  }

  if (onFetched) {
    inflightByOrg[orgId].callbacks.push(onFetched);
  }

  return inflightByOrg[orgId].promise;
};
